import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "How do online astrology consultations work?",
    a: "You connect with the astrologer directly via WhatsApp, phone or video call. You share your date, time and place of birth, ask your questions, and receive a chart-based reading with practical remedies. There's no need to search for an 'astrologer near me' — distance does not affect the reading.",
  },
  {
    q: "What can I ask an astrologer?",
    a: "You can ask about marriage timing, career changes, finance, health concerns, relationship compatibility, education choices, business decisions, and recurring life patterns. The clearer your question, the deeper the reading.",
  },
  {
    q: "How do I choose the best astrologer in India?",
    a: "Look at their years of experience, the systems they specialise in (Vedic, KP, Nadi, etc.), client reviews, response time and pricing. Our ranking already filters for these. Start with the top-listed astrologer that matches your specific need.",
  },
  {
    q: "What should I expect from my first consultation?",
    a: "A good astrologer will first ask for your accurate birth details, then briefly outline what the chart shows. They'll address your specific questions, suggest 1–3 practical remedies (mantra, ritual or behavioural), and answer follow-ups for clarity.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-slate-50 border-y border-slate-200">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[#16a3a8] mb-6">
          Frequently Asked Questions (FAQ)
        </h2>

        <div className="space-y-2">
          {faqs.map((f, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left"
                onClick={() => setOpen(open === i ? -1 : i)}
              >
                <span className="font-semibold text-[#0b1e3f]">{f.q}</span>
                <ChevronDown
                  className={`w-4 h-4 text-slate-500 transition-transform ${
                    open === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              {open === i && (
                <div className="px-5 pb-4 text-sm text-slate-700 leading-relaxed fade-in">
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
